/**
 * Lookbook Page Scripts (Shopify版)
 */
(function() {
    'use strict';

    var modalState = {
        isOpen: false,
        images: [],
        currentIndex: 0,
        previousActiveElement: null
    };

    /**
     * サイズフィルター機能
     */
    function initSizeFilter() {
        var filterButtons = document.querySelectorAll('.p-lookbookFilter_button');
        var stylingItems = document.querySelectorAll('.p-lookbookStyling_item');

        if (filterButtons.length === 0 || stylingItems.length === 0) return;

        filterButtons.forEach(function(button) {
            button.addEventListener('click', function() {
                var size = button.dataset.size;

                filterButtons.forEach(function(btn) {
                    btn.classList.remove('is-active');
                });
                button.classList.add('is-active');

                stylingItems.forEach(function(item) {
                    var itemSize = item.dataset.size;
                    if (size === 'all' || itemSize === size) {
                        item.classList.remove('is-hidden');
                    } else {
                        item.classList.add('is-hidden');
                    }
                });
            });
        });
    }

    /**
     * サイズ比較スライダー
     */
    function initSizeSlider() {
        var sliderElement = document.querySelector('.js-lookbook-slider');

        if (!sliderElement || typeof Splide === 'undefined') return;

        var slides = sliderElement.querySelectorAll('.splide__slide');
        var slideCount = slides.length;

        if (slideCount === 0) return;

        // PC: 2枚表示、2枚ずつ送り / SP: 1枚表示、1枚ずつ送り
        var splide = new Splide(sliderElement, {
            type: 'slide',
            perPage: 2,
            perMove: 2,
            gap: '20px',
            arrows: false,
            pagination: slideCount > 2,
            drag: true,
            touch: true,
            breakpoints: {
                768: {
                    perPage: 1,
                    perMove: 1,
                    pagination: slideCount > 1
                }
            }
        });

        splide.mount();

        var prevButton = document.querySelector('.p-lookbookSize_arrow.mod-prev');
        var nextButton = document.querySelector('.p-lookbookSize_arrow.mod-next');

        if (prevButton) {
            prevButton.addEventListener('click', function() {
                splide.go('<');
            });
        }

        if (nextButton) {
            nextButton.addEventListener('click', function() {
                splide.go('>');
            });
        }
    }

    /**
     * スタイリングカードモーダル
     */
    function initStylingCardModal() {
        var modal = document.querySelector('.js-styling-modal');
        var cards = document.querySelectorAll('.js-styling-card');
        var closeButtons = document.querySelectorAll('.js-modal-close');
        var mainImage = document.querySelector('.js-modal-main-image');
        var thumbnailsContainer = document.querySelector('.js-modal-thumbnails');
        var prevButton = document.querySelector('.js-modal-prev');
        var nextButton = document.querySelector('.js-modal-next');

        if (!modal || !mainImage || !thumbnailsContainer) return;

        cards.forEach(function(card) {
            card.addEventListener('click', function() {
                var thumbnail = card.dataset.thumbnail;
                var subImagesAttr = card.getAttribute('data-sub-images');

                if (!thumbnail) return;

                var images = [thumbnail];
                if (subImagesAttr) {
                    try {
                        var subImages = JSON.parse(subImagesAttr);
                        if (Array.isArray(subImages) && subImages.length > 0) {
                            images = images.concat(subImages);
                        }
                    } catch (e) {
                        console.error('サブ画像のパースエラー:', e);
                    }
                }

                openModal(modal, images, mainImage, thumbnailsContainer);
            });
        });

        closeButtons.forEach(function(button) {
            button.addEventListener('click', function() {
                closeModal(modal);
            });
        });

        if (prevButton) {
            prevButton.addEventListener('click', function() {
                navigateImage(-1, mainImage, thumbnailsContainer);
            });
        }

        if (nextButton) {
            nextButton.addEventListener('click', function() {
                navigateImage(1, mainImage, thumbnailsContainer);
            });
        }

        document.addEventListener('keydown', function(e) {
            if (!modalState.isOpen) return;

            switch (e.key) {
                case 'Escape':
                    closeModal(modal);
                    break;
                case 'ArrowLeft':
                    navigateImage(-1, mainImage, thumbnailsContainer);
                    break;
                case 'ArrowRight':
                    navigateImage(1, mainImage, thumbnailsContainer);
                    break;
            }
        });
    }

    function openModal(modal, images, mainImage, thumbnailsContainer) {
        modalState.previousActiveElement = document.activeElement;
        modalState.images = images;
        modalState.currentIndex = 0;

        thumbnailsContainer.innerHTML = images.map(function(src, index) {
            return '<button class="p-lookbookModal_thumbnail' + (index === 0 ? ' is-active' : '') + '" type="button" data-index="' + index + '" aria-label="画像 ' + (index + 1) + '"><img src="' + src + '" alt="サムネイル ' + (index + 1) + '" loading="lazy" /></button>';
        }).join('');

        var thumbnails = thumbnailsContainer.querySelectorAll('.p-lookbookModal_thumbnail');
        thumbnails.forEach(function(thumb) {
            thumb.addEventListener('click', function() {
                var index = parseInt(thumb.dataset.index || '0', 10);
                setActiveImage(index, mainImage, thumbnailsContainer);
            });
        });

        mainImage.src = images[0];
        modal.hidden = false;
        modalState.isOpen = true;
        document.body.style.overflow = 'hidden';

        // スワイプ操作の追加
        initModalSwipe(mainImage, thumbnailsContainer);

        var closeButton = modal.querySelector('.js-modal-close');
        if (closeButton) {
            closeButton.focus();
        }
    }

    /**
     * モーダル画像のスワイプ操作
     */
    function initModalSwipe(mainImage, thumbnailsContainer) {
        var touchStartX = 0;
        var touchEndX = 0;
        var minSwipeDistance = 50;

        var imageContainer = mainImage.parentElement;

        function handleTouchStart(e) {
            touchStartX = e.changedTouches[0].screenX;
        }

        function handleTouchEnd(e) {
            touchEndX = e.changedTouches[0].screenX;
            handleSwipe();
        }

        function handleSwipe() {
            var diff = touchStartX - touchEndX;
            if (Math.abs(diff) < minSwipeDistance) return;

            if (diff > 0) {
                // 左スワイプ → 次へ
                navigateImage(1, mainImage, thumbnailsContainer);
            } else {
                // 右スワイプ → 前へ
                navigateImage(-1, mainImage, thumbnailsContainer);
            }
        }

        // 既存のリスナーを削除してから追加
        imageContainer.removeEventListener('touchstart', handleTouchStart);
        imageContainer.removeEventListener('touchend', handleTouchEnd);
        imageContainer.addEventListener('touchstart', handleTouchStart, { passive: true });
        imageContainer.addEventListener('touchend', handleTouchEnd, { passive: true });
    }

    function closeModal(modal) {
        modal.hidden = true;
        modalState.isOpen = false;
        modalState.images = [];
        modalState.currentIndex = 0;
        document.body.style.overflow = '';

        if (modalState.previousActiveElement) {
            modalState.previousActiveElement.focus();
            modalState.previousActiveElement = null;
        }
    }

    function navigateImage(direction, mainImage, thumbnailsContainer) {
        if (modalState.images.length === 0) return;

        var newIndex = modalState.currentIndex + direction;

        if (newIndex < 0) {
            newIndex = modalState.images.length - 1;
        } else if (newIndex >= modalState.images.length) {
            newIndex = 0;
        }

        setActiveImage(newIndex, mainImage, thumbnailsContainer);
    }

    function setActiveImage(index, mainImage, thumbnailsContainer) {
        if (index < 0 || index >= modalState.images.length) return;

        modalState.currentIndex = index;
        mainImage.src = modalState.images[index];

        var thumbnails = thumbnailsContainer.querySelectorAll('.p-lookbookModal_thumbnail');
        thumbnails.forEach(function(thumb, i) {
            if (i === index) {
                thumb.classList.add('is-active');
                thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            } else {
                thumb.classList.remove('is-active');
            }
        });
    }

    /**
     * 初期化
     */
    function init() {
        initSizeFilter();
        initSizeSlider();
        initStylingCardModal();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    // Shopifyテーマエディタ対応
    document.addEventListener('shopify:section:load', init);
})();
